'use client';

import React, { useState } from 'react';
import { Input, Button, Tooltip } from '@heroui/react';
import { FaArrowLeft, FaPaperPlane } from 'react-icons/fa';
import AIModal from './AIModal';
import { SessionType } from '@/util/types/globalTypes';
import { BsStars } from 'react-icons/bs';

interface AISearchInputProps {
  className?: string;
  onBack: () => void;
  session: SessionType;
}

export default function AISearchInput({
  className,
  onBack,
  session,
}: AISearchInputProps) {
  const [inputValue, setInputValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialQuestion, setInitialQuestion] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputValue.trim()) {
      setInitialQuestion(inputValue.trim());
      setIsModalOpen(true);
      setInputValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onBack();
    }
  };

  return (
    <>
      <div className={className}>
        <form onSubmit={handleSubmit} className='flex items-center gap-2'>
          <Tooltip
            content='Back to search'
            placement='bottom'
            color='foreground'
            closeDelay={50}
            showArrow
          >
            <Button
              isIconOnly
              variant='light'
              size='sm'
              radius='full'
              onPress={onBack}
              aria-label='Back to search'
              className='flex-shrink-0'
            >
              <FaArrowLeft size={14} />
            </Button>
          </Tooltip>

          <div className='relative flex-1'>
            <Input
              placeholder='Ask Attik AI anything...'
              value={inputValue}
              onValueChange={setInputValue}
              onKeyDown={handleKeyDown}
              size='md'
              variant='bordered'
              radius='full'
              classNames={{
                inputWrapper: 'shadow-none bg-white border',
                input: 'text-sm',
              }}
              startContent={
                <BsStars size={14} className='animate-pulse text-primary' />
              }
              endContent={
                <Button
                  isIconOnly
                  variant='light'
                  size='sm'
                  type='submit'
                  isDisabled={!inputValue.trim()}
                  className='flex-shrink-0'
                >
                  <FaPaperPlane size={14} />
                </Button>
              }
            />
          </div>
        </form>
      </div>

      <AIModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialQuestion={initialQuestion}
        session={session}
      />
    </>
  );
}
